<script lang="ts">
import type { Snippet } from 'svelte';

import { ETitleFontSizes } from '../../../config/enums';

interface Props {
    includeGutter?: boolean;
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    titleSize?: string;
    children?: Snippet;
}

let {
    includeGutter = false,
    headingLevel = 'h3',
    titleSize = ETitleFontSizes.H2,
    children,
}: Props = $props();

const titleSizeClassName = $derived(`section-header--${titleSize}`);
</script>

<svelte:element
    this={headingLevel}
    class="section-header {titleSizeClassName}"
    class:section-header--include-gutter={includeGutter}
>
    {@render children?.()}
</svelte:element>

<style lang="scss">
    @use '/src/scss/global-constants/typography';
    @use 'sass-mq/mq' as *;

    .section-header {
        margin-bottom: 3rem;

        @include mq($from: tablet) {
            margin-bottom: 7rem;
        }

        &--include-gutter {
            padding-left: var(--layout-pagegrid-margin);
            padding-right: var(--layout-pagegrid-margin);
        }

        &--h1 {
            @include typography.display-xl;
        }

        &--h1-5 {
            @include typography.display-hero;
        }

        &--h2 {
            @include typography.display-lg;
        }

        &--h3 {
            @include typography.display-md;
        }

        &--h4 {
            @include typography.heading-lg;
        }

        &--h5 {
            @include typography.heading-md;
        }
    }
</style>
